module.exports = __webpack_public_path__ + "img/36_50.49246735.png";